import React, { useEffect, useState } from 'react';
import AdminShell from '../components/AdminShell';
import { api } from '../lib/api';

const AdminAudit = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get('/admin/audit').then((r) => setRows(r.data.items || [])); }, []);
  return (
    <AdminShell title="Audit log">
      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto" data-testid="audit-table">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F5F2] text-left"><tr>
            <th className="px-4 py-3 font-semibold">When</th><th className="px-4 py-3 font-semibold">Admin</th><th className="px-4 py-3 font-semibold">Action</th><th className="px-4 py-3 font-semibold">Target</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-black/5" data-testid={`audit-row-${r.id}`}>
                <td className="px-4 py-3 text-xs text-[#4B5563]">{r.created_at?.slice(0,19).replace('T', ' ')}</td>
                <td className="px-4 py-3 text-sm">{r.admin_email || '—'}</td>
                <td className="px-4 py-3 font-mono text-xs">{r.action}</td>
                <td className="px-4 py-3 text-xs text-[#4B5563]">{r.target || '—'}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={4} className="px-4 py-8 text-center text-[#4B5563]">No audit entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
};

export default AdminAudit;
